import React, { useState, useEffect, useRef } from 'react';
import './LockScreen.css'; // Adicione estilos personalizados conforme necessário

const LockScreen = () => {
    const [isLocked, setIsLocked] = useState(localStorage.getItem('lock') === 'S');
    const [inputPassword, setInputPassword] = useState('');
    const correctPassword = localStorage.getItem('access') ? atob(localStorage.getItem('access')) : '';
    const inactivityTimeoutRef = useRef(null);

    const resetTimeout = () => {
        if (inactivityTimeoutRef.current) {
            clearTimeout(inactivityTimeoutRef.current);
        }
        inactivityTimeoutRef.current = setTimeout(() => {
            setIsLocked(true);
            localStorage.setItem('lock', 'S');
        }, 20 * 60 * 1000); // 20 minutos em milissegundos
    };

    useEffect(() => {
        const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];

        const handleEvent = () => {
            resetTimeout();
        };

        events.forEach(event => {
            window.addEventListener(event, handleEvent);
        });

        resetTimeout();

        return () => {
            events.forEach(event => {
                window.removeEventListener(event, handleEvent);
            });
            if (inactivityTimeoutRef.current) {
                clearTimeout(inactivityTimeoutRef.current);
            }
        };
    }, []);

    const handleUnlock = () => {
        if (inputPassword === correctPassword) {
            setIsLocked(false);
            localStorage.setItem('lock', 'N');
            setInputPassword('');
            resetTimeout();
        } else {
            alert('Senha incorreta!');
        }
    };

    if (!isLocked) {
        return null;
    }

    return (
        <div className="lock-screen-overlay">
            <div className="lock-screen-content">
                <img src="Images/icon-user.png" alt="User Icon" className="user-icon" /> {/* Ajuste o caminho do ícone conforme necessário */}
                <h2>{localStorage.getItem('username')}</h2> {/* Altere para o nome real do usuário */}
                <p>Por favor, insira sua senha para desbloquear.</p>
                <input
                    type="password"
                    value={inputPassword}
                    onChange={(e) => setInputPassword(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleUnlock();
                        }
                    }}
                    placeholder="Senha"
                    className="password-input"
                />
                <button onClick={handleUnlock} className="unlock-button">Desbloquear</button>
            </div>
        </div>
    );
};

export default LockScreen;
